import styled from 'styled-components';
import Link from 'next/link';

import { t } from 'localization/utils/t';
import { APP_DOWNLOAD_LINK_APP_PAGE } from '../enums/appLandingPageEnums';

const TP = 'appLanding.components.AndroidCta';

export const AndroidCta = ({ link }: { link?: string }) => (
  <Link href={link || APP_DOWNLOAD_LINK_APP_PAGE}>
    <a aria-label={t(`${TP}.downloadTheGoatApp`, 'Download the GOAT App')}>
      <AndroidCta.Img
        data-qa="android_download_app"
        src="/images/google-play-badge.png"
        alt={t(`${TP}.googlePlayCta`, 'Google Play CTA')}
      />
    </a>
  </Link>
);

AndroidCta.Img = styled.img`
  height: 60px;
`;
